import { useRoleType } from "./useRoleType";
import { getDocumentSortAllowedRoles } from "../../services/user/roleService";

/**
 * TEMPORAL — bypass de permisos para maquetar/validar la UI de "Ordenación de expedientes por
 * Nº documento" mientras backend no esté devolviendo correctamente el permiso del feature
 * (GET /users/me/modules y/o /users/me/views) para los roles habilitados.
 *
 * Cuando backend confirme que el permiso llega correctamente:
 * 1. Poner `FORCE_SHOW_FOR_TESTING` en `false` (o eliminarlo).
 * 2. Verificar que el control deja de verse para roles no autorizados.
 * 3. Eliminar este comentario y, si se quiere, este hook, volviendo a usar
 *    `useRoleType(getDocumentSortAllowedRoles())` directamente en los 3 puntos de uso.
 */
const FORCE_SHOW_FOR_TESTING = false;

export const useIsDocumentSortAllowed = (): boolean => {
    const isRoleAllowed = useRoleType(getDocumentSortAllowedRoles());
    return isRoleAllowed || FORCE_SHOW_FOR_TESTING;
};
